import { PRODUCT_ID } from '~/constants';

export enum BRANDING_KEY {
  LOGIN_PROMPT = 'LOGIN_PROMPT',
  DEFAULT_REDIRECT = 'DEFAULT_REDIRECT',
  CAN_CREATE_ACCOUNT = 'CAN_CREATE_ACCOUNT',
  PUBLIC_BLURB = 'PUBLIC_BLURB',
  PUBLIC_CLASSNAME = 'PUBLIC_CLASSNAME',
  PRODUCT_LOGO = 'PRODUCT_LOGO',
  SIGN_UP_ENDPOINT = 'SIGN_UP_ENDPOINT',
}

export type BRANDING_KEY_TYPE = keyof typeof BRANDING_KEY;
export type BRANDING_KEY_VALUE = (typeof BRANDING_KEY)[BRANDING_KEY_TYPE];

export const BrandConfigurationFiles: Record<PRODUCT_ID, string> = {
  [PRODUCT_ID.GENERIC]: 'generic',
};
